import React from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { LABELS } from '../../keys';
import { OrderPwcSectionProps } from '../../types';
import { Item, ItemName, ItemValue, OnChainTransactionHash, SectionWrapper } from '../styles';

export const SettlementDetailsSection = ({ orderData, rowId }: OrderPwcSectionProps) => {
  const { t } = useTranslation();

  const cryptoExchange = orderData?.charges.find((charge) => charge.uuid === rowId)?.cryptoExchange;

  return (
    <Panel label={t(LABELS.SECTIONS.SETTLEMENT_DETAILS.TITLE)}>
      <SectionWrapper>
        <Item>
          <ItemName>{t(LABELS.SECTIONS.EXCHANGE_DETAILS.EXCHANGE_STATUS)}</ItemName>
          <ItemValue>{cryptoExchange?.exchangeStatus}</ItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.SECTIONS.EXCHANGE_DETAILS.SETTLEMENT_PAYMENT_RAIL)}</ItemName>
          <ItemValue>{cryptoExchange?.settlementPaymentRail?.toUpperCase()}</ItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.SECTIONS.EXCHANGE_DETAILS.SETTLEMENT_CURRENCY)}</ItemName>
          <ItemValue>{cryptoExchange?.settlementCurrency?.toUpperCase()}</ItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.SECTIONS.EXCHANGE_DETAILS.DESTINATION_WALLET)}</ItemName>
          <ItemValue>{cryptoExchange?.crypto?.wallet}</ItemValue>
        </Item>
        <Item>
          <ItemName>{t(LABELS.SECTIONS.EXCHANGE_DETAILS.SETTLEMENT_TRANSACTION_HASH)}</ItemName>
          <OnChainTransactionHash displayFullHash>
            <a href={cryptoExchange?.crypto?.onChain?.explorerUrl} target="_blank">
              {cryptoExchange?.crypto?.onChain?.transactionHash}
            </a>
          </OnChainTransactionHash>
        </Item>
      </SectionWrapper>
    </Panel>
  );
};
